<template>
  <div class="progress" v-if="progress !== null">
    <div
      class="survey progress-bar bg-accent"
      role="progressbar"
      :style="{ width: progress + '%' }"
      :aria-valuenow="progress"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-label="$t('generic.progress')"
    ></div>
  </div>
</template>
<script>
export default {
  props: {
    progress: {
      type: Number,
      default: null,
    },
  },
};
</script>
